import { type UUID } from '~/types/common';

/**
 * Find and return the full item from the given bulk data by its ID.
 * @param entityId - The ID of the entity to find.
 * @param bulkData - The bulk data to search through.
 * @returns The full item from the given bulk data by its ID.
 */
export const getBulkEntityDetails = <T extends { id: UUID }>(
  entityId: UUID,
  bulkData: T[] = [],
): T | undefined => {
  return bulkData?.find(({ id }) => id === entityId);
};
